import React from "react";
import "./Blog.scss";

export default function CodeBlock({ children }) {
  const [copied, setCopied] = React.useState(false);

  const copy = () => {
    navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 5000);
  };

  return (
    <div className="code-block">
      <div className="copy" onClick={copy}>
        {copied ? "Copied" : "Copy"}
      </div>
      <pre>{children}</pre>
    </div>
  );
}
